/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Visibility_Public_DescInputs */

const en_dialog_visibility_public_desc = /** @type {(inputs: Dialog_Visibility_Public_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anyone on the internet can view & listen`)
};

const es_dialog_visibility_public_desc = /** @type {(inputs: Dialog_Visibility_Public_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cualquier persona en internet puede ver y escuchar`)
};

/**
* | output |
* | --- |
* | "Anyone on the internet can view & listen" |
*
* @param {Dialog_Visibility_Public_DescInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_visibility_public_desc = /** @type {((inputs?: Dialog_Visibility_Public_DescInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Visibility_Public_DescInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_visibility_public_desc(inputs)
	return en_dialog_visibility_public_desc(inputs)
});